function downloadFile(url) {
    const tempLink = document.createElement('a');
    tempLink.href = url;
    tempLink.download = '';
    tempLink.style.display = 'none';

    document.body.appendChild(tempLink);

    tempLink.click();

    document.body.removeChild(tempLink);

    setTimeout(() => {
        location.reload();
    }, 100);
}

// Appliquer un écouteur aux liens concernés
document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.visual_item-link').forEach(link => {
        link.addEventListener('click', event => {
            event.preventDefault();
            const url = link.getAttribute('href');
            downloadFile(url);
        });
    });
});
